var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDarCaretDown = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 14,
  rx: 7,
  fill: "#E3F4FF"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.8934 5.71141L7.25725 9.87781C7.22348 9.91654 7.18338 9.94727 7.13924 9.96824C7.0951 9.98921 7.04778 10 7 10C6.95222 10 6.9049 9.98921 6.86076 9.96824C6.81662 9.94727 6.77652 9.91654 6.74275 9.87781L3.10664 5.71141C3.05573 5.65314 3.02106 5.57888 3.007 5.49801C2.99295 5.41715 3.00015 5.33333 3.02769 5.25715C3.05524 5.18098 3.10189 5.11589 3.16174 5.07011C3.22158 5.02434 3.29194 4.99994 3.3639 5H10.6361C10.7081 4.99994 10.7784 5.02434 10.8383 5.07011C10.8981 5.11589 10.9448 5.18098 10.9723 5.25715C10.9998 5.33333 11.0071 5.41715 10.993 5.49801C10.9789 5.57888 10.9443 5.65314 10.8934 5.71141Z",
  fill: "#7BC9FF"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDarCaretDown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dar_caret_down.7243878ea18b014dc0a0e4ad76c9f218.svg";